import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['syncEmployee'];

  connect() {
    this.checkSyncStatus();
  }

  disconnect() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  checkSyncStatus() {
    let company = $(this.syncEmployeeTarget).data('companyId');
    let integration = $(this.syncEmployeeTarget).data('integrationId');

    this.intervalId = setInterval(() => {
      Rails.ajax({
        url: `/companies/${company}/integrations/${integration}/sync_status`,
        type: 'GET',
        dataType: 'script',
        success: (data) => {
          if (data.status !== 'in_progress') {
            clearInterval(this.intervalId);
            this.intervalId = null;

            if (!this.element.isConnected) return;

            window.location.href = `/companies/${company}/integrations/${integration}?step=sync_employees`;
          }
        }
      });
    }, 5000);
  }
}
